import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { BancoService } from '../../features/banco/banco.service';
import { AlertService } from '../../shared/services/alert.service';

export const BancoAccessGuard: CanActivateFn = () => {
  const bancoService = inject(BancoService);
  const alertService = inject(AlertService);
  const router = inject(Router);

  return bancoService.verificarAcesso().pipe(
    map(({ permitido }) => {
      if (permitido) {
        return true;
      }
      alertService.warning(
        'Para cadastrar ou editar seus dados bancários, é necessário primeiro realizar a confirmação de interesse na vaga.'
      );
      return router.createUrlTree(['/home']);
    }),
    // Fail-closed: em caso de erro na verificação, nega o acesso por segurança.
    catchError(() => {
      alertService.warning(
        'Não foi possível verificar seu acesso aos dados bancários. Tente novamente mais tarde.'
      );
      return of(router.createUrlTree(['/home']));
    })
  );
};
